import Raven from 'raven-js'
import moment from 'lib/utils/moment'
import ErrorTracker from '../error-tracker'

async function trackWithAJS(error, options = {}) {
  const payload = await ErrorTracker.extractErrorInfo(error, options)
  ErrorTracker.logFullStory('JavaScript Error')
  window.analytics.track('JavaScript Error', payload)
}

// @see https://docs.getsentry.com/hosted/clients/javascript/usage/#raven-js-reporting-errors
export async function track(err, options = {}) {
  // don't let raven cause more exceptions...
  try {
    Raven.captureException(err, options)
    await trackWithAJS(err, options)
    console.error(err)
  } catch (e) {
    console.error(e)
  }
}

export async function trackSlothOfDeath(err, extraContext = {}) {
  try {
    const errorInfo = await ErrorTracker.extractErrorInfo(err)
    const payload = {
      ...extraContext,
      ...errorInfo
    }
    window.analytics.track('Sloth Of Death', payload)
    ErrorTracker.logFullStory('Sloth of Death')
  } catch (e) {
    console.error(e)
  }
}

/*
  Network Errors are errors that occurr at Network interface
  layer that connects the App to Gateway-API
*/
export async function trackNetworkError(networkError, operation = '') {
  try {
    const errorInfo = await ErrorTracker.extractErrorInfo(networkError)

    const payload = {
      operation,
      statusCode: networkError.statusCode,
      ...errorInfo
    }

    window.analytics.track('Network Error', payload)
    ErrorTracker.logFullStory('Network Error')
  } catch (e) {
    console.error(e)
  }
}

/*
  GraphQL errors are usually validation errors or common invalid paths
  usually related to invalid requests to GraphQL.
*/
export function trackGraphQLErrors(graphqlErrors) {
  try {
    const timezone = moment.tz.guess()
    const sentryId = Raven.lastEventId()
    const fullStory = ErrorTracker.getFullStory()
    const route = ErrorTracker.currentRoute

    const payload = {
      fullStory,
      timezone,
      sentryId,
      route,
      graphqlErrors
    }

    ErrorTracker.logFullStory('GraphQL Error')
    window.analytics.track('GraphQL Error', payload)
  } catch (e) {
    console.error(e)
  }
}

/*
  Transactional errors are errors our users make that prevent them from
  completing a task.

  These are not necessarily crashes, but moments of frustration when
  users attempted to perform an invalid task or were prevent from finishing
  that task by a server error/crash.
*/
export function trackTransactionalError(displayName = '', props = {}) {
  try {
    const timezone = moment.tz.guess()
    const sentryId = Raven.lastEventId()
    const failedGraphQLQueries = ErrorTracker.failedApolloQueries()
    const fullStory = ErrorTracker.getFullStory()
    const route = ErrorTracker.currentRoute

    const payload = {
      displayName,
      fullStory,
      timezone,
      sentryId,
      failedGraphQLQueries,
      route,
      ...props
    }

    ErrorTracker.logFullStory('Transactional Error')
    window.analytics.track('Transactional Error', payload)
  } catch (e) {
    console.error(e)
  }
}
